import { SVGProps } from '@components/Icon/types';

export const Edit = ({ fill = '#000', size = 24, ...props }: SVGProps) => (
  <svg
    width={`${size}px`}
    height={`${size}px`}
    fill="none"
    viewBox="0 0 24 24"
    xmlns="http://www.w3.org/2000/svg"
    xmlnsXlink="http://www.w3.org/1999/xlink"
    {...props}>
    <g id="Edit">
      <g id="Union">
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M5.14938 18.2227L5.11621 17.9296C5.13285 18.0146 5.1412 18.0894 5.14535 18.1426C5.14743 18.1693 5.14844 18.1902 5.14893 18.2041L5.14934 18.2192L5.14938 18.2227Z"
          fill={fill}
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M20.932 2.72331C20.4498 2.24108 19.8123 1.99826 19.1771 2.00001C18.5411 2.00008 17.9053 2.24096 17.4229 2.72331L17.1555 2.98899L14.6347 5.5098V5.51147L3.75484 16.3896L2.06103 20.7956C1.78597 21.5111 2.48891 22.214 3.20442 21.939L7.61159 20.2447L7.70366 20.1502L7.70546 20.1483L21.0114 6.84406L21.2769 6.57694C22.2429 5.6124 22.2426 4.03391 21.2767 3.06802L20.932 2.72331ZM18.3072 3.6093L18.1814 3.73589L20.2641 5.81861L20.3905 5.69303C20.874 5.20781 20.8739 4.43716 20.3907 3.95401L20.046 3.6093C19.8035 3.36677 19.4907 3.24792 19.177 3.24636C18.8628 3.24647 18.55 3.36656 18.3072 3.6093ZM16.3255 5.59102L18.409 7.67454L19.3777 6.70585L17.2942 4.62232L16.3255 5.59102ZM5.50725 16.4109C5.62383 16.4759 5.74008 16.559 5.84899 16.6679C6.16826 16.9872 6.28137 17.3754 6.33893 17.6615C6.62492 17.7192 7.0117 17.8325 7.33166 18.1506C7.44056 18.2595 7.52408 18.3762 7.5891 18.4927L17.5213 8.56054L15.4395 6.47869L5.50725 16.4109ZM5.14938 18.8489H5.77419L5.77714 18.849L5.79272 18.8496C5.80689 18.8502 5.82824 18.8514 5.85525 18.8537C5.90929 18.8583 5.98488 18.867 6.07017 18.8838C6.15088 18.9004 6.23563 18.9274 6.30795 18.9587C6.38498 18.9921 6.43009 19.0227 6.44607 19.0387L6.44748 19.0401C6.46232 19.0546 6.49262 19.0984 6.5257 19.1752C6.54264 19.2145 6.55822 19.2576 6.57146 19.3019L4.29595 20.1779L3.8221 19.704L4.69785 17.4277C4.7422 17.4412 4.78541 17.4569 4.82482 17.4739C4.90214 17.5072 4.94646 17.5374 4.96131 17.5522C4.97726 17.5682 5.00791 17.6133 5.04125 17.6904C5.07257 17.7629 5.09956 17.8481 5.11621 17.9296L5.14938 18.2227L5.14938 18.8489Z"
          fill={fill}
        />
      </g>
    </g>
  </svg>
);

export const ICON_NAME = 'edit';
